@if (kpi.isLoading()) {
  <div
    class="@container flex flex-col gap-5 px-6 pt-5 pb-4 rounded-lg outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode"
  >
    <div class="flex gap-2 items-center">
      <ui-skeleton class="flex-none rounded-full size-5" />
      <ui-skeleton class="flex-1 h-3 w-full rounded-lg" />
      <ui-skeleton class="w-[116px] h-10 flex-none rounded-md" />
    </div>

    <div class="grid grid-cols-2 @md:grid-cols-3 gap-3">
      <div
        class="p-3 bg-surface-variant dark:bg-surface-variant-darkmode rounded-md flex flex-col gap-0.5"
      >
        <ui-skeleton class="block h-3 w-[50%] rounded-full" />
        <div class="grid grid-cols-2 gap-0.5 items-end">
          <ui-skeleton class="inline-block h-11 w-full rounded-full" />
          <ui-skeleton class="inline-block h-4.5 w-full rounded-full" />
        </div>
      </div>

      <div
        class="p-3 bg-surface-variant dark:bg-surface-variant-darkmode rounded-md flex flex-col gap-0.5"
      >
        <ui-skeleton class="block h-3 w-[50%] rounded-full" />
        <div class="grid grid-cols-2 gap-0.5 items-end">
          <ui-skeleton class="inline-block h-11 w-full rounded-full" />
          <ui-skeleton class="inline-block h-4.5 w-full rounded-full" />
        </div>
      </div>

      <div
        class="p-3 bg-surface-variant dark:bg-surface-variant-darkmode rounded-md flex flex-col gap-0.5"
      >
        <ui-skeleton class="block h-3 w-[50%] rounded-full" />
        <div class="grid grid-cols-2 gap-0.5 items-end">
          <ui-skeleton class="inline-block h-11 w-full rounded-full" />
          <ui-skeleton class="inline-block h-4.5 w-full rounded-full" />
        </div>
      </div>
    </div>
    <ui-skeleton class="block w-full h-10 rounded-md" />
  </div>
} @else {
  <div
    class="@container flex flex-col gap-5 px-6 pt-5 pb-4 rounded-lg outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode"
  >
    @if (kpi.error()) {
      <app-error-component
        class="block h-[206px]"
        (clickRetry)="kpi.reload()"
        [enableRetry]="true"
      />
    } @else {
      <div class="flex gap-2 items-center">
        <ng-icon name="heroCurrencyEuro" size="20" class="flex-none !block" />
        <span class="flex-1 text-base font-semibold leading-6 line-clamp-1">
          {{ 'cockpit.analysis.hpfc.title' | transloco }}
        </span>
        <ui-switch-bar class="w-[116px] inline-block flex-none" [formField]="settingsForm.type">
          <ui-switch-bar-option value="AVERAGE">
            <span class="text-2xl font-normal leading-5">⌀</span>
          </ui-switch-bar-option>
          <ui-switch-bar-option value="LOW">
            <ng-icon name="heroArrowDown" size="20" class="!block" />
          </ui-switch-bar-option>
          <ui-switch-bar-option value="HIGH">
            <ng-icon name="heroArrowUp" size="20" class="!block" />
          </ui-switch-bar-option>
        </ui-switch-bar>
      </div>

      <div class="grid grid-cols-2 @md:grid-cols-3 gap-3">
        <div
          class="p-3 bg-surface-variant dark:bg-surface-variant-darkmode rounded-md flex flex-col gap-0.5"
        >
          <div class="text-on-surface-subtle text-sm font-normal leading-5">
            {{ 'cockpit.analysis.hpfc.today' | transloco }}
          </div>
          @if (todayValue(); as today) {
            <app-responsive-value [value]="today | germanNumber: 0">{{
              'cockpit.analysis.hpfc.unitCentPerKwh' | transloco
            }}</app-responsive-value>
          }
        </div>

        <div
          class="p-3 bg-surface-variant dark:bg-surface-variant-darkmode rounded-md flex flex-col gap-0.5"
        >
          <div class="text-on-surface-subtle text-sm font-normal leading-5">
            {{ 'cockpit.analysis.hpfc.tomorrow' | transloco }}
          </div>
          @if (tomorrowValue(); as tomorrow) {
            <app-responsive-value [value]="tomorrow | germanNumber: 0">{{
              'cockpit.analysis.hpfc.unitCentPerKwh' | transloco
            }}</app-responsive-value>
          }
        </div>

        <div
          class="col-span-2 @md:col-span-1 p-3 bg-surface-variant dark:bg-surface-variant-darkmode rounded-md flex flex-col gap-0.5"
        >
          <div class="text-on-surface-subtle text-sm font-normal leading-5">
            {{ 'cockpit.analysis.hpfc.week' | transloco }}
          </div>
          @if (weekValue(); as week) {
            <app-responsive-value [value]="week | germanNumber: 0">{{
              'cockpit.analysis.hpfc.unitCentPerKwh' | transloco
            }}</app-responsive-value>
          }
        </div>
      </div>

      <ui-button
        mode="outlined"
        expand="full"
        class="w-full block"
        [routerLink]="['/organizations', organizationId(), 'analysis', 'price']"
        data-track="analysis-hpfc-view-prices-button"
      >
        {{ 'cockpit.analysis.hpfc.viewPrices' | transloco }}
        <ng-icon name="heroArrowRight" size="20" slot="end" class="!block" />
      </ui-button>
    }
  </div>
}
